import React from 'react';
import styled from 'styled-components';
import { getEffectivenessPercentage } from '../utils/formatters';

const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 150px;
`;

const SliderTrack = styled.div`
  position: relative;
  height: 3px;
  width: 100%;
  background: linear-gradient(to right, #f49090 0%, #f1b46f 50%, #6aedca 100%);
  border-radius: 1.5px;
  margin: 8px 0;
`;

const SliderThumb = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 50%;
  top: 50%;
  left: ${props => props.percentage}%;
  transform: translate(-50%, -50%);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

const SliderValue = styled.div`
  font-weight: 600;
  font-size: 0.875rem;
  text-align: center;
  color: var(--text-primary);
`;

const SliderLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-top: 2px;
`;

const EffectivenessSlider = ({ value }) => {
  const percentage = getEffectivenessPercentage(value);
  
  return (
    <SliderContainer>
      <SliderValue>{value !== null && value !== undefined ? value : 'N/A'}</SliderValue>
      <SliderTrack>
        {value !== null && value !== undefined && (
          <SliderThumb percentage={percentage} />
        )}
      </SliderTrack>
      <SliderLabels>
        <span>Low</span>
        <span>High</span>
      </SliderLabels>
    </SliderContainer>
  );
};

export default EffectivenessSlider;
